import { supabase } from '@/integrations/supabase/client';
import { ApiResult, ok, err, ApiError } from '../errors';

// ============ Avatar Storage ============

export async function uploadAvatar(
  userId: string,
  file: File
): Promise<ApiResult<string>> {
  const fileExt = file.name.split('.').pop();
  const fileName = `${userId}-${crypto.randomUUID()}.${fileExt}`;
  const filePath = `${userId}/${fileName}`;

  const { error: uploadError } = await supabase.storage
    .from('avatars')
    .upload(filePath, file);

  if (uploadError) {
    return err(ApiError.fromSupabaseError(uploadError));
  }

  const { data: { publicUrl } } = supabase.storage
    .from('avatars')
    .getPublicUrl(filePath);

  return ok(publicUrl);
}

// ============ Cover Image Storage ============

export async function uploadCoverImage(
  folder: string,
  file: File
): Promise<ApiResult<string>> {
  const fileExt = file.name.split('.').pop();
  const fileName = `${folder}/${crypto.randomUUID()}.${fileExt}`;

  const { error: uploadError } = await supabase.storage
    .from('covers')
    .upload(fileName, file);

  if (uploadError) {
    return err(ApiError.fromSupabaseError(uploadError));
  }

  const { data: { publicUrl } } = supabase.storage
    .from('covers')
    .getPublicUrl(fileName);

  return ok(publicUrl);
}
